import { EChartsOption, graphic } from "echarts";
import { optionTypes } from "src/helpers";

export const API_RESPONSE_SAMPLE = {
    "demandCharges": {
        "amount": "65000"
    },
    "comparisonDashboard": [
        {
            "title": "Demand Charges",
            "value": "600",
            "percentage": "9%",
            "trend": "up",
            "beforeMYT": "549"
        },
        {
            "title": "Energy Charges",
            "value": "8.68",
            "percentage": "4%",
            "trend": "up",
            "beforeMYT": "8.36"
        },
        {
            "title": "Demand Charges",
            "value": "0.74",
            "percentage": "19%",
            "trend": "up",
            "beforeMYT": "0.62"
        }
    ],
    "todRebates": [
        {
            "title": "Zone A (₹/unit)",
            "value": "NA",
            "percentage": "",
            "trend": "none",
            "beforeMYT": "-1.5"
        },
        {
            "title": "Zone B (₹/unit)",
            "value": "NA",
            "percentage": "",
            "trend": "none",
            "beforeMYT": "₹0"
        },
        {
            "title": "Zone C (₹/unit)",
            "value": "-1.3",
            "percentage": "-15%",
            "trend": "down",
            "beforeMYT": "0.8"
        },
        {
            "title": "Zone D (₹/unit)",
            "value": "2.17",
            "percentage": "25%",
            "trend": "up",
            "beforeMYT": "1.1"
        }
    ],
    "overallImpact": {
        "percentage": "~15%",
        "trend": "increase",
        "description": "Overall Progress",
        "series": [
            { "value": 1048, "name": "Before MYT" },
            { "value": 735, "name": "After MYT" }
        ]
    }
}


export const OG_API_RESPONSE = {
    "comparison Dashboard": {
        "demandCharges": {
            "parameter": "Demand Charges (₹/kVA)",
            "beforeMYT": 549,
            "afterMYT": 600,
            "percentageChange": "+9%"
        },
        "energyCharges": {
            "parameter": "Energy Charges (₹/kWh)",
            "beforeMYT": 8.36,
            "afterMYT": 8.68,
            "percentageChange": "+4%"
        },
        "wheelingCharges": {
            "parameter": "Wheeling Charges (₹/kWh)",
            "beforeMYT": 0.6,
            "afterMYT": 0.74,
            "percentageChange": "+23%"
        }
    },
    "Zone-wise Rebates": {
        "zoneA": {
            "parameter": "ToD Zone A",
            "beforeMYT": "₹-1.5/unit",
            "afterMYT": null,
            "percentageChange": null
        },
        "zoneB": {
            "parameter": "ToD Zone B",
            "beforeMYT": "₹0/unit",
            "afterMYT": null,
            "percentageChange": null
        },
        "zoneC": {
            "parameter": "ToD Zone C",
            "beforeMYT": "₹0.8/unit",
            "afterMYT": "₹-1.736/unit",
            "percentageChange": "Reduced"
        },
        "zoneD": {
            "parameter": "ToD Zone D",
            "beforeMYT": "₹1.1/unit",
            "afterMYT": "₹2.17/unit",
            "percentageChange": "Escalated from ₹1.1/unit to ₹2.17/unit"
        }
    },
    "Sample Bill Comparison": {
        "units": 4010551,
        "components": {
            "DemandCharges": {
                "parameter": "Demand Charges",
                "oldTariff": 35685000,
                "newTariff": 39000000,
                "change": "+3315000"
            },
            "WheelingCharges": {
                "parameter": "Wheeling Charges",
                "oldTariff": 0,
                "newTariff": 0,
                "change": 0
            },
            "EnergyCharges": {
                "parameter": "Energy Charges",
                "oldTariff": 33528206.36,
                "newTariff": 34811582.68,
                "change": "+1283376.3200000003"
            },
            "ZoneRebates": {
                "parameter": "Zone Rebates",
                "oldTariff": -846259.9999999999,
                "newTariff": 256909.19333333336,
                "change": "+1103169.1933333334"
            },
            "FAC": {
                "parameter": "FAC @0.65/unit",
                "rate": 0.65,
                "oldTariff": 2606858.15,
                "newTariff": 2606858.15,
                "change": 0
            },
            "ElectricityDuty": {
                "parameter": "Electricity Duty @7.5%",
                "rate": 7.5,
                "oldTariff": 5323035.33825,
                "newTariff": 5750651.251750001,
                "change": "+427615.9135000007"
            },
            "TaxOnSale": {
                "parameter": "Tax On Sale @0.18/unit",
                "rate": 0.18,
                "oldTariff": 360,
                "newTariff": 360,
                "change": 0
            }
        },
        "total": {
            "parameter": "Total",
            "oldTariff": 76297199.84825,
            "newTariff": 82426361.27508335,
            "change": "+6129161.4268333465",
            "percentageIncrease": "9%"
        }
    },
    "Impact of Changes in ToD tariff and banking provisions": {
        "zoneA": {
            "name": "ToD Zone A",
            "beforeMYT": {
                "rate": -1.5,
                "hours": 8,
                "timeslot": "12AM-6AM, 10PM-12AM",
                "units": 1334100,
                "rebateRate": "₹-1.5/unit",
                "rebateAmount": -2001150
            },
            "afterMYT": {
                "rate": null,
                "hours": 6,
                "timeslot": "12AM-6AM",
                "units": 1000575,
                "rebateRate": null,
                "rebateAmount": 0
            }
        },
        "zoneB": {
            "name": "ToD Zone B",
            "beforeMYT": {
                "rate": 0,
                "hours": 9,
                "timeslot": "6AM-9AM, 12PM-6PM",
                "units": 1489301,
                "rebateRate": "₹0/unit",
                "rebateAmount": 0
            },
            "afterMYT": {
                "rate": null,
                "hours": 3,
                "timeslot": "6AM-9AM",
                "units": 496433.6666666666,
                "rebateRate": null,
                "rebateAmount": 0
            }
        },
        "zoneC": {
            "name": "ToD Zone C",
            "beforeMYT": {
                "rate": 0.8,
                "hours": 3,
                "timeslot": "9AM-12PM",
                "units": 503250,
                "rebateRate": "₹0.8/unit",
                "rebateAmount": 402600
            },
            "afterMYT": {
                "rate": -1.736,
                "hours": 8,
                "timeslot": "9AM-5PM",
                "units": 1330639.4444444445,
                "rebateRate": "₹-1.736/unit",
                "rebateAmount": -2309990.0755555555
            }
        },
        "zoneD": {
            "name": "ToD Zone D",
            "beforeMYT": {
                "rate": 1.1,
                "hours": 4,
                "timeslot": "6PM-10PM",
                "units": 683900,
                "rebateRate": "₹1.1/unit",
                "rebateAmount": 752290.0000000001
            },
            "afterMYT": {
                "rate": 2.17,
                "hours": 7,
                "timeslot": "5PM-12AM",
                "units": 1182902.888888889,
                "rebateRate": "₹2.17/unit",
                "rebateAmount": 2566899.268888889
            }
        }
    }
}

// Interfaces for type safety
export interface DemandChargesProps {
    amount: string;
}

export interface ComparisonCardProps {
    title: string;
    value: string;
    percentage: string;
    trend: "up" | "none" | "down" | any;
    beforeMYT: string;
}

export interface ComparisonDashboardProps {
    items: ComparisonCardProps[];
}

export interface ToDRebatesProps {
    items: ComparisonCardProps[];
}


export interface OverallImpactProps {
    percentage: string;
    trend: string;
    description: string;
    series: { value: number; name: string }[];
    // [key as string]: any
    data?: any
}



export const API_RESP_INIT = {
    "comparison Dashboard": {
        "DemandCharges": {
            "parameter": "Demand Charges (₹/kVA)",
            "beforeMYT": null,
            "afterMYT": null,
            "percentageChange": null
        },
        "EnergyCharges": {
            "parameter": "Energy Charges (₹/kWh)",
            "beforeMYT": null,
            "afterMYT": null,
            "percentageChange": null
        },
        "WheelingCharges": {
            "parameter": "Wheeling Charges (₹/kWh)",
            "beforeMYT": null,
            "afterMYT": null,
            "percentageChange": null
        }
    },
    "Zone-wise Rebates": {
        "zoneA": {
            "parameter": "ToD Zone A",
            "beforeMYT": null,
            "afterMYT": null,
            "percentageChange": null
        },
        "zoneB": {
            "parameter": "ToD Zone B",
            "beforeMYT": null,
            "afterMYT": null,
            "percentageChange": null
        },
        "zoneC": {
            "parameter": "ToD Zone C",
            "beforeMYT": null,
            "afterMYT": null,
            "percentageChange": null
        },
        "zoneD": {
            "parameter": "ToD Zone D",
            "beforeMYT": null,
            "afterMYT": null,
            "percentageChange": null
        }
    },
    "Sample Bill Comparison": {
        "units": 0,
        "components": {
            "DemandCharges": {
                "parameter": "Demand Charges",
                "oldTariff": null,
                "newTariff": null,
                "change": null
            },
            "EnergyCharges": {
                "parameter": "Energy Charges",
                "oldTariff": null,
                "newTariff": null,
                "change": null
            },
            "WheelingCharges": {
                "parameter": "Wheeling Charges",
                "oldTariff": null,
                "newTariff": null,
                "change": null
            },
            "ZoneRebates": {
                "parameter": "Zone Rebates",
                "oldTariff": null,
                "newTariff": null,
                "change": null
            },
            "FAC": {
                "parameter": "FAC @0/unit",
                "rate": null,
                "oldTariff": null,
                "newTariff": null,
                "change": null
            },
            "ElectricityDuty": {
                "parameter": "Electricity Duty ",
                "rate": null,
                "oldTariff": null,
                "newTariff": null,
                "change": null
            },
            "TaxOnSale": {
                "parameter": "Tax On Sale @0/unit",
                "rate": null,
                "oldTariff": null,
                "newTariff": null,
                "change": null
            }
        },

    },
    "Impact of Changes in ToD tariff and banking provisions": {
        "zoneA": {
            "name": "ToD Zone A",
            "beforeMYT": {
                "hours": null,
                "timeslot": null,
                "units": null,
                "rebateRate": null,
                "rebateAmount": null
            },
            "afterMYT": {
                "hours": null,
                "timeslot": null,
                "units": null,
                "rebateRate": null,
                "rebateAmount": null
            }
        },
        "zoneB": {
            "name": "ToD Zone B",
            "beforeMYT": {
                "hours": null,
                "timeslot": null,
                "units": null,
                "rebateRate": null,
                "rebateAmount": null
            },
            "afterMYT": {
                "hours": null,
                "timeslot": null,
                "units": null,
                "rebateRate": null,
                "rebateAmount": null
            }
        },
        "zoneC": {
            "name": "ToD Zone C",
            "beforeMYT": {
                "hours": null,
                "timeslot": null,
                "units": null,
                "rebateRate": null,
                "rebateAmount": null
            },
            "afterMYT": {
                "hours": null,
                "timeslot": null,
                "units": null,
                "rebateRate": null,
                "rebateAmount": null
            }
        },
        "zoneD": {
            "name": "ToD Zone D",
            "beforeMYT": {
                "hours": null,
                "timeslot": null,
                "units": null,
                "rebateRate": null,
                "rebateAmount": null
            },
            "afterMYT": {
                "hours": null,
                "timeslot": null,
                "units": null,
                "rebateRate": null,
                "rebateAmount": null
            }
        }
    }
}

export const zoneColors: any = {
    'Zone A': '#1e1b4b', // Red
    // 'Zone B': '#3b82f6', // Orange
    // 'Zone B': '#fef08a', // Orange
    'Zone B': '#60a5fa', // Orange

    // 'Zone C': '#60a5fa', // Light Orange
    'Zone C': '#fdba74', // Light Orange

    'Zone D': '#1d4ed8', // Gold
    'Zone H': '#f9fafb',  // Gray (default)
    'Zone F': '#111827'  // Gray (default)
};

function convertTo24Hour(timeStr: any, returnHour = true, returnMin = false) {
    // Normalize the string by removing all spaces and converting to uppercase
    let normalized = timeStr.replace(/\s/g, '').toUpperCase();

    // Extract the modifier (AM/PM) if present
    let modifier = '';
    if (normalized.includes('AM') || normalized.includes('PM')) {
        modifier = normalized.slice(-2);
        normalized = normalized.slice(0, -2);
    }

    // Ensure a colon separator exists for consistent parsing
    if (!normalized.includes(':')) {
        // If no minutes specified, default to ':00'
        normalized += ':00';
    }

    // Handle cases where AM/PM wasn't specified but hours exceed 12
    let [hours, minutes] = normalized.split(':');

    if (modifier === '') {
        hours = parseInt(hours, 10);
        if (hours >= 12) {
            modifier = 'PM';
            if (hours > 12) {
                hours -= 12;
            }
        } else {
            modifier = 'AM';
        }
        hours = hours.toString().padStart(2, '0');
        // hours =
    }

    // Convert to 24-hour format
    if (modifier === 'PM') {
        hours = hours === '12' ? '12' : (parseInt(hours, 10) + 12).toString();
    } else if (modifier === 'AM') {
        hours = hours === '12' ? '00' : hours.padStart(2, '0');
    }

    // Ensure minutes are properly formatted
    minutes = minutes.padStart(2, '0');

    if (returnHour) {
        if (returnMin) {
            return `${hours}:${minutes}`;
        }
        return parseInt(hours);
    }
    return `${hours}:${minutes}`;
}

function mergeHourRanges(data: any) {
    // First, sort the data based on 'from' value
    const sortedData = [...data].sort((a, b) => a.from - b.from);

    const ranges = [];
    let currentRange = null;

    for (const entry of sortedData) {
        if (!currentRange) {
            currentRange = { from: entry.from, to: entry.to };
        } else if (entry.from === currentRange.to) {
            // Extend the current range
            currentRange.to = entry.to;
        } else {
            // Finalize current range and start a new one
            ranges.push({
                from: currentRange.from,
                to: currentRange.to,
                // totalHours: currentRange.to - currentRange.from,
                isMissing: true,
            });
            currentRange = { from: entry.from, to: entry.to };
        }
    }

    // Add the last range if it exists
    if (currentRange) {
        ranges.push({
            from: currentRange.from,
            to: currentRange.to,
            // totalHours: currentRange.to - currentRange.from,
            isMissing: true,
        });
    }

    return ranges;
}

function findMissingHours(ranges: any) {
    console.table(ranges);

    let defaultRenges = [...new Array(24)].reduce((acc, curr, currIndx) => {
        acc.push({ from: currIndx, to: currIndx == 23 ? 0 : currIndx + 1 });
        return acc;
    }, []);

    // console.table(defaultRenges);
    for (var k = 0; k < ranges.length; k++) {
        let _from = ranges[k]?.from;
        let _to = ranges[k]?.to;
        // console.log({ _from, _to });
        defaultRenges = defaultRenges.filter((x: any) =>
            _to != 0
                ? x?.from < _from || x?.from > _to || x?.to > _to
                : x?.from < _from && x?.to > _to
        );
        // console.table(defaultRenges);
    }
    // console.table(defaultRenges);
    return defaultRenges?.length > 0 ? mergeHourRanges(defaultRenges) : [];
}

const sortArrayByFrom = (arr: any[]) => {
    return arr.sort((a: any, b: any) => a.from - b.from);
};

const prepareTotalHours = (data: any[]) => {
    return data.map((d: any) => {
        return {
            ...d,
            totalHours: d?.to !== 0 ? d?.to - d?.from : 24 - d?.from,
        };
    });
};



const timeColorMap = {
    0: "#172554",
    1: "#172554",
    2: "#172554",
    3: "#172554",
    4: "#1e3a8a",
    5: "#1e3a8a",
    6: "#2563eb",
    7: "#3b82f6",
    8: "#93c5fd",
    9: "#93c5fd",
    10: "#93c5fd",
    12: "#93c5fd",
    13: "#93c5fd",
    14: "#93c5fd",
    15: "#93c5fd",
    16: "#93c5fd",
    17: "#93c5fd",
    18: "#93c5fd",
    19: "#3b82f6",
    20: "#3b82f6",
    21: "#1e3a8a",
    22: "#172554",
    23: "#172554",
    24: "#172554",
};

function getColorAtHour(hour: any) {
    return timeColorMap[hour as keyof object];
}

function getZoneGradientColors(from: any, to: any) {
    // Get the color at the start time (from)
    const startColor = getColorAtHour(from);
    const endTime = to === 0 ? 24 : to;
    const endColor = getColorAtHour(endTime);

    return [startColor, endColor]
}

function getLabelColor(hour: any) {
    if (hour >= 22 && hour <= 24) {
        return "#fff"
    }
    else if (hour >= 0 && hour <= 7) {
        return "#fff"
    }
    else
        return "#333"
}


export const prepareChartData = (data: any[]) => {
    // Function to get gradient based on time range
    const getGradientForTime = (from: number, to: number) => {
        console.log({ from, to });

        let [startColor, endColor] = getZoneGradientColors(from, to)

        return new graphic.LinearGradient(0, 0, 0, 1, from >= 17 ? [
            { offset: 1, color: startColor },
            { offset: 0, color: endColor }
        ] : [
            { offset: 0, color: startColor },
            { offset: 1, color: endColor }
        ]);
    };

    return data.reduce((acc: any, curr: any) => {
        acc.push({
            name: curr?.isMissing ? "H" : curr?.zone?.replace("Zone", "").trim(),
            value: 4.16 * curr?.totalHours,
            itemStyle: {
                // color: getGradientForTime(curr?.from, curr?.to),
                color: curr?.isMissing ? "#f9fafb" : zoneColors[curr?.zone]
            },
            label: {
                color: getLabelColor(curr?.to == 0 ? 24 : curr?.to),
                show: true // Ensure label is visible; adjust as needed
            }
        });
        return acc;
    }, []);
};

export const prepare24HrsChartData = () => {
    return [...new Array(24)].map((_, indx: number) => {
        return {
            name: `${indx + 1}`,
            value: 4.16,
            itemStyle: { color: "#111827" },
        };
    });
};


export function extractData(data: any) {
    let _beforeMYTData: any = [];
    let _afterMYTData: any = [];

    for (const zoneKey in data) {
        const zone = data[zoneKey];
        const zoneName = zone.name;
        // Process beforeMYT
        zone.beforeMYT.timeslot.split(',').forEach((slot: any) => {
            const [from, to] = slot.trim().split('-');
            _beforeMYTData.push({
                from: convertTo24Hour(from),
                to: convertTo24Hour(to),
                zone: zoneName?.replace('ToD', '').trim(),
            });
        });
        // Process afterMYT
        zone.afterMYT.timeslot.split(',').forEach((slot: any) => {
            const [from, to] = slot.trim().split('-');
            _afterMYTData.push({
                from: convertTo24Hour(from),
                to: convertTo24Hour(to),
                zone: zoneName?.replace('ToD', '').trim(),
            });
        });
    }
    _beforeMYTData = sortArrayByFrom(_beforeMYTData);
    _afterMYTData = sortArrayByFrom(_afterMYTData);

    _beforeMYTData = prepareTotalHours(sortArrayByFrom([
        ...findMissingHours(_beforeMYTData),
        ..._beforeMYTData,
    ]));
    _afterMYTData = prepareTotalHours(sortArrayByFrom([
        ...findMissingHours(_afterMYTData),
        ..._afterMYTData,
    ]));

    _beforeMYTData = prepareChartData(_beforeMYTData)
    _afterMYTData = prepareChartData(_afterMYTData)

    return { _beforeMYTData, _afterMYTData };
}


export interface OriginalApiResponse {
    "comparison Dashboard": {
        demandCharges: {
            parameter: string;
            beforeMYT: number;
            afterMYT: number;
            percentageChange: string;
        };
        energyCharges: {
            parameter: string;
            beforeMYT: number;
            afterMYT: number;
            percentageChange: string;
        };
        wheelingCharges: {
            parameter: string;
            beforeMYT: number;
            afterMYT: number;
            percentageChange: string;
        };
    };
    "Zone-wise Rebates": {
        zoneA: {
            parameter: string;
            beforeMYT: string;
            afterMYT: string | null;
            percentageChange: string | null;
        };
        zoneB: {
            parameter: string;
            beforeMYT: string;
            afterMYT: string | null;
            percentageChange: string | null;
        };
        zoneC: {
            parameter: string;
            beforeMYT: string;
            afterMYT: string | null;
            percentageChange: string | null;
        };
        zoneD: {
            parameter: string;
            beforeMYT: string;
            afterMYT: string | null;
            percentageChange: string | null;
        };
    };
    "Sample Bill Comparison": {
        units: number;
        components: {
            [key: string]: {
                parameter: string;
                oldTariff: number;
                newTariff: number;
                change: number | string;
                rate?: number;
            };
        };
        total: {
            parameter: string;
            oldTariff: number;
            newTariff: number;
            change: string;
            percentageIncrease: string;
        };
    };
    "Impact of Changes in ToD tariff and banking provisions": {
        [key: string]: {
            name: string;
            beforeMYT: {
                rate: number | null;
                hours: number;
                timeslot: string;
                units: number;
                rebateRate: string;
                rebateAmount: number;
            };
            afterMYT: {
                rate: number | null;
                hours: number;
                timeslot: string;
                units: number;
                rebateRate: string | null;
                rebateAmount: number;
            };
        };
    };
}

// Define interface for zoneColors
export interface ZoneColors {
    zoneA: string;
    zoneB: string;
    zoneC: string;
    zoneD: string;
}

type ZoneData = {
    zone: string;
    units: number;
    fill: string;
    amount: number;
};

// Define interfaces for the transformed API response structure
export interface TransformedApiResponse {
    demandCharges: {
        amount: string;
    };
    comparisonDashboard: Array<{
        title: string;
        value: string;
        percentage: any;
        trend: "up" | "down" | "none";
        beforeMYT: string;
    }>;
    todRebates: Array<{
        title: string;
        value: string;
        percentage: string;
        trend: "up" | "down" | "none";
        beforeMYT: string;
    }>;
    overallImpact: {
        percentage: string;
        trend: "increase" | "decrease" | "none";
        description: string;
        series: Array<{
            value: number;
            name: string;
        }>;
    };
    ToDImpactComparisonChartData: any[]
}

export function convertApiResponse(
    ogResponse: OriginalApiResponse,
    formData: any
): TransformedApiResponse {
    // Helper function to calculate percentage change
    const calculatePercentageChange = (before: number | null, after: number | null): string => {
        if (before === null || after === null || before === 0) return "";
        const change = ((after - before) / Math.abs(before)) * 100;
        return change >= 0 ? `+${Math.round(change)}%` : `${Math.round(change)}%`;
    };

    // Helper function to determine trend
    const determineTrend = (percentage: string): "up" | "down" | "none" => {
        if (!percentage) return "none";
        return percentage.startsWith("+") ? "up" : "down";
    };

    // demandCharges: Hardcode "65000" as per sample (source unclear)
    const demandCharges: TransformedApiResponse["demandCharges"] = {
        amount: formData?.contractDemand
    };


    // comparisonDashboard: Map from "comparison Dashboard"
    const comparisonDashboard: TransformedApiResponse["comparisonDashboard"] = [
        {
            title: "Demand Charges",
            value: ogResponse["comparison Dashboard"].demandCharges.afterMYT?.toString(),
            percentage: ogResponse["comparison Dashboard"].demandCharges.percentageChange,
            trend: determineTrend(ogResponse["comparison Dashboard"].demandCharges.percentageChange),
            beforeMYT: ogResponse["comparison Dashboard"].demandCharges.beforeMYT?.toString()
        },
        {
            title: "Energy Charges",
            value: ogResponse["comparison Dashboard"].energyCharges.afterMYT?.toString(),
            percentage: ogResponse["comparison Dashboard"].energyCharges.percentageChange,
            trend: determineTrend(ogResponse["comparison Dashboard"].energyCharges.percentageChange),
            beforeMYT: ogResponse["comparison Dashboard"].energyCharges.beforeMYT?.toString()
        },
        {
            title: "Wheeling Charges",
            value: ogResponse["comparison Dashboard"].wheelingCharges.afterMYT?.toString(),
            percentage: ogResponse["comparison Dashboard"].wheelingCharges.percentageChange,
            trend: determineTrend(ogResponse["comparison Dashboard"].wheelingCharges.percentageChange),
            beforeMYT: ogResponse["comparison Dashboard"].wheelingCharges.beforeMYT?.toString()
        }
    ];

    // todRebates: Map from "Zone-wise Rebates"
    const todRebates: TransformedApiResponse["todRebates"] = [
        {
            title: "Zone A (₹/unit)",
            value: ogResponse["Zone-wise Rebates"].zoneA.afterMYT
                ? ogResponse["Zone-wise Rebates"].zoneA.afterMYT.replace("₹", "").replace("/unit", "")
                : "NA",
            percentage: ogResponse["Zone-wise Rebates"].zoneA.percentageChange || "",
            trend: determineTrend(ogResponse["Zone-wise Rebates"].zoneA.percentageChange || ""),
            beforeMYT: ogResponse["Zone-wise Rebates"].zoneA.beforeMYT.replace("₹", "").replace("/unit", "")
        },
        {
            title: "Zone B (₹/unit)",
            value: ogResponse["Zone-wise Rebates"].zoneB.afterMYT
                ? ogResponse["Zone-wise Rebates"].zoneB.afterMYT.replace("₹", "").replace("/unit", "")
                : "NA",
            percentage: ogResponse["Zone-wise Rebates"].zoneB.percentageChange || "",
            trend: determineTrend(ogResponse["Zone-wise Rebates"].zoneB.percentageChange || ""),
            beforeMYT: ogResponse["Zone-wise Rebates"].zoneB.beforeMYT.replace("₹", "").replace("/unit", "")
        },
        {
            title: "Zone C (₹/unit)",
            value: ogResponse["Zone-wise Rebates"].zoneC.afterMYT
                ? ogResponse["Zone-wise Rebates"].zoneC.afterMYT.replace("₹", "").replace("/unit", "")
                : "NA",
            percentage: ogResponse["Zone-wise Rebates"].zoneC.percentageChange === "Reduced"
                ? "Reduced"
                : calculatePercentageChange(
                    parseFloat(ogResponse["Zone-wise Rebates"].zoneC.beforeMYT.replace("₹", "").replace("/unit", "")),
                    parseFloat(ogResponse["Zone-wise Rebates"].zoneC.afterMYT?.replace("₹", "").replace("/unit", "") || "0")
                ),
            trend: ogResponse["Zone-wise Rebates"].zoneC.percentageChange === "Reduced"
                ? "down"
                : determineTrend(calculatePercentageChange(
                    parseFloat(ogResponse["Zone-wise Rebates"].zoneC.beforeMYT.replace("₹", "").replace("/unit", "")),
                    parseFloat(ogResponse["Zone-wise Rebates"].zoneC.afterMYT?.replace("₹", "").replace("/unit", "") || "0")
                )),
            beforeMYT: ogResponse["Zone-wise Rebates"].zoneC.beforeMYT.replace("₹", "").replace("/unit", "")
        },
        {
            title: "Zone D (₹/unit)",
            value: ogResponse["Zone-wise Rebates"].zoneD.afterMYT
                ? ogResponse["Zone-wise Rebates"].zoneD.afterMYT.replace("₹", "").replace("/unit", "")
                : "NA",
            percentage: calculatePercentageChange(
                parseFloat(ogResponse["Zone-wise Rebates"].zoneD.beforeMYT.replace("₹", "").replace("/unit", "")),
                parseFloat(ogResponse["Zone-wise Rebates"].zoneD.afterMYT?.replace("₹", "").replace("/unit", "") || "0")
            ),
            trend: determineTrend(calculatePercentageChange(
                parseFloat(ogResponse["Zone-wise Rebates"].zoneD.beforeMYT.replace("₹", "").replace("/unit", "")),
                parseFloat(ogResponse["Zone-wise Rebates"].zoneD.afterMYT?.replace("₹", "").replace("/unit", "") || "0")
            )),
            beforeMYT: ogResponse["Zone-wise Rebates"].zoneD.beforeMYT.replace("₹", "").replace("/unit", "")
        }
    ];

    // ToDImpactComparisonChartData: Map from "Impact of Changes in ToD tariff and banking provisions"
    let ToDImpactComparisonChartData: any = {}


    // overallImpact: Map from "Sample Bill Comparison"
    const overallImpact: TransformedApiResponse["overallImpact"] = {
        percentage: ogResponse["Sample Bill Comparison"].total.percentageIncrease,
        trend: "increase",
        description: "Overall Bill Impact",
        series: [
            { value: parseFloat((ogResponse["Sample Bill Comparison"].total.oldTariff / 1000).toFixed(3)), name: "Before MYT" },
            { value: parseFloat((ogResponse["Sample Bill Comparison"].total.newTariff / 1000).toFixed(3)), name: "After MYT" }
        ]
    };

    return {
        demandCharges,
        comparisonDashboard,
        todRebates,
        overallImpact,
        ToDImpactComparisonChartData
    };
}


export function generateToDChartOptions(data: any[], metric: 'units' | 'rebateAmount'): EChartsOption {

    const zones: any = ['A', 'B', 'C', 'D'];
    const beforeMYTData: any[] = [];
    const afterMYTData: any[] = [];

    console.log({ zones });


    zones.forEach((zoneKey: any) => {
        const zone = data[zoneKey as keyof object];
        if (!zone) return; // Skip if zone data is missing

        const beforeMYT = zone.beforeMYT
        const afterMYT = zone.afterMYT

        console.log({ data, zone, beforeMYT, afterMYT });

        if (beforeMYT) {
            beforeMYTData.push({
                value: beforeMYT[metric],
                itemStyle: {
                    color: beforeMYT[metric] < 0 ? '#FF0000' : beforeMYT.fill
                }
            });
        }

        if (afterMYT) {
            afterMYTData.push({
                value: afterMYT[metric],
                itemStyle: {
                    color: afterMYT[metric] < 0 ? '#FF0000' : afterMYT.fill
                }
            });
        }
    });

    return { beforeMYTData, afterMYTData }
}


export interface ContextProps {
    formData: any
    updateFormData: (e: any) => void,
    apiRespData: any
    updateApiRespData: (e: any) => void,
    showFormDialog: boolean
    updateShowFromDialog: (e: any) => void,
}

export const initialContext = {
    formData: undefined,
    updateFormData: () => { },
    apiRespData: undefined,
    updateApiRespData: () => { },
    showFormDialog: false,
    updateShowFromDialog: () => { },
}
